import { sm4 } from 'gm-crypt';

import JSONBIG from 'json-bigint';

// 创建SM4实例的函数，支持自定义key和iv
function createSM4Instance(customKey = null, customIv = null) {
  let key, iv;

  if (customKey && customIv) {
    // 使用自定义的key和iv
    key = customKey;
    iv = customIv;
  } else {
    // 从cookie中获取动态key和iv
    const keyIvString = '1234567891012456 1234567891012456';
    if (keyIvString && keyIvString.includes(' ')) {
      const [dynamicKey, dynamicIv] = keyIvString.split(' ');
      if (dynamicKey && dynamicIv && dynamicKey.length === 16 && dynamicIv.length === 16) {
        key = dynamicKey;
        iv = dynamicIv;
      } else {
        throw new Error('动态key和iv格式不正确');
      }
    } else {
      throw new Error('未找到有效的key和iv');
    }
  }

  const sm4Config = {
    key: key,
    iv: iv,
    mode: 'cbc',
    cipherType: 'base64'
  };
  return new sm4(sm4Config);
}

/*
 * text 待加密文本
 * customKey 自定义key（16位），如果不传则从cookie中获取
 * customIv 自定义iv（16位），如果不传则从cookie中获取
 */
export function sm4Encrypt(text, customKey = null, customIv = null) {
  text = JSON.stringify(text);
  // 如果没有传入customKey和customIv，从cookie中获取
  if (!customKey || !customIv) {
   // const keyIvString =getdecrypt();
    const keyIvString = '1234567891012456 1234567891012456';
    if (keyIvString && keyIvString.includes(' ')) {
      const [cookieKey, cookieIv] = keyIvString.split(' ');
      customKey = customKey || cookieKey;
      customIv = customIv || cookieIv;
    }
  }

  const sm4Util = createSM4Instance(customKey, customIv);
  return sm4Util.encrypt(text);
}

/*
 * text 待解密密文
 * customKey 自定义key（16位），如果不传则从cookie中获取
 * customIv 自定义iv（16位），如果不传则从cookie中获取
 */
export function sm4Decrypt(text, customKey = null, customIv = null) {
  // 如果没有传入customKey和customIv，从cookie中获取
  if (!customKey || !customIv) {
   // const keyIvString = getdecrypt();
    const keyIvString = '1234567891012456 1234567891012456';
    //console.log("秘钥",keyIvString)
    //console.log("加密值：",text)
    if (keyIvString && keyIvString.includes(' ')) {
      const [cookieKey, cookieIv] = keyIvString.split(' ');
      customKey = customKey || cookieKey;
      customIv = customIv || cookieIv;
    }
  }

  const sm4Util = createSM4Instance(customKey, customIv);
  let decString = sm4Util.decrypt(text);

  // 添加与原 AES 解密函数相同的 JSON 解析逻辑
  if (decString.charAt(0) === "{" || decString.charAt(0) === "[") {
    const json = JSONBIG({
      storeAsString: true
    });
    decString = json.parse(decString);
  }
//console.log("解密后：",decString)
  return decString;
}

export function getKey(length = 16) {
	let random = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
	let str = "";
	for (let i = 0; i < length; i++) {
		str = str + random.charAt(Math.random() * random.length)
	}
	return str;
}